import BackDocuments from './backDocuments';

export default class BackDrafts extends BackDocuments {
  hasChange = false;
  hasDeleted = false;
}
